var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileCreation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.356,
    height: 30.368,
    viewBox: "0 0 30.356 30.368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7657"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3714",
    d: "M0 1.365c.088-.018.084-.1.107-.161a1.75 1.75 0 0 1 1.605-1.2c.108-.01.217-.005.326-.005h21.084a1.82 1.82 0 0 1 2.027 2.032V8.08a.67.67 0 0 1-.337.674.573.573 0 0 1-.817-.377 1.515 1.515 0 0 1-.033-.381V1.977c0-.586-.2-.79-.78-.79h-21.2c-.6 0-.793.2-.793.807v26.391c0 .6.2.8.8.8h21.175c.6 0 .8-.2.8-.8v-4.062c0-.489.335-.775.752-.658a.554.554 0 0 1 .427.572c.006 1.492.021 2.985-.011 4.477a1.681 1.681 0 0 1-1.383 1.6c-.04.009-.076.012-.084.061h-22.3c0-.047-.038-.063-.077-.075a1.773 1.773 0 0 1-1.213-1.213c-.012-.039-.029-.072-.075-.076z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3715",
    d: "M3497.87 1102.1a2.5 2.5 0 0 1 2.068 3.852c-1.495 2.539-2.951 5.1-4.424 7.654l-2.852 4.943a1.658 1.658 0 0 1-.466.525q-1.745 1.276-3.483 2.563a.748.748 0 0 1-.623.207.587.587 0 0 1-.452-.7c.081-.835.178-1.669.27-2.5.069-.628.146-1.255.209-1.884a1.633 1.633 0 0 1 .206-.671q3.646-6.311 7.289-12.623a2.512 2.512 0 0 1 2.258-1.366zm-6.095 15.523c.095-.031.112-.115.15-.18q2.883-4.991 5.769-9.983c.079-.136.093-.2-.063-.289a67.76 67.76 0 0 1-1.92-1.109c-.161-.1-.208-.036-.282.092q-2.886 5.008-5.781 10.01c-.088.152-.059.208.081.287.636.357 1.266.725 1.9 1.088zm5.916-14.341a1.167 1.167 0 0 0-.913.568c-.2.313-.38.643-.574.963-.06.1-.043.147.054.2q1 .57 1.994 1.15c.089.052.151.073.212-.04.2-.364.435-.708.593-1.087a1.317 1.317 0 0 0-1.366-1.75zm-6.75 15.236-1.153-.67c-.539-.311-.539-.311-.625.286 0 .02-.008.039-.01.058l-.194 1.788z",
    transform: "translate(-3469.969 -1094.697)",
    style: {
      fill: "#030303"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3716",
    d: "M3345.721 1051a5.456 5.456 0 1 1 5.467 5.461 5.476 5.476 0 0 1-5.467-5.461zm2.035 2.52a4.122 4.122 0 0 1 1.589-1.371c.128-.062.123-.118.052-.222a2.491 2.491 0 0 1-.325-1.821 2.123 2.123 0 0 1 3.234-1.53 2.511 2.511 0 0 1 .693 3.29c-.081.13-.153.214.047.307a3.712 3.712 0 0 1 1.438 1.2c.1.138.146.136.241-.009a4.257 4.257 0 1 0-6.97.155zm3.255 1.754a4.576 4.576 0 0 0 2.6-.768c.118-.081.129-.13.057-.251a2.979 2.979 0 0 0-4.969-.005c-.067.113-.078.168.048.254a4.326 4.326 0 0 0 2.264.774zm1.116-4.691a.972.972 0 0 0-1.006-1.142.955.955 0 0 0-.883.814 1.157 1.157 0 0 0 .634 1.407.97.97 0 0 0 1.255-1.075z",
    transform: "translate(-3338.603 -1042.348)",
    style: {
      fill: "#f84525"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3717",
    d: "M11.58 16.015h4.206a.59.59 0 0 1-.013 1.18c-.069.006-.138 0-.208 0h-8a2.122 2.122 0 0 1-.237 0 .589.589 0 0 1 .013-1.177c.088-.009.178 0 .266 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3718",
    d: "M11.567 20.523H7.479c-.521 0-.83-.365-.672-.786a.6.6 0 0 1 .628-.4H15.667c.425.008.7.248.7.6s-.282.584-.713.585q-2.043.003-4.087.001z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3719",
    d: "M11.581 22.657h4.147a.593.593 0 1 1 .014 1.184H7.388a.593.593 0 1 1 .015-1.184h.207z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3720",
    d: "M14.189 25.979h1.479c.425 0 .7.245.7.6s-.281.586-.71.587H12.7c-.431 0-.707-.231-.714-.583s.277-.6.724-.6c.493-.004.986-.004 1.479-.004z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3721",
    d: "M3308.042 1218.58a.6.6 0 0 1-.59.576.59.59 0 1 1 .029-1.179.6.6 0 0 1 .561.603z",
    transform: "translate(-3302.636 -1201.958)",
    style: {
      fill: "#030303"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3722",
    d: "M3307.462 1262.661a.59.59 0 1 1-.028 1.18.59.59 0 0 1 .028-1.18z",
    transform: "translate(-3302.633 -1243.323)",
    style: {
      fill: "#030303"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3723",
    d: "M3308.041 1307.962a.6.6 0 0 1-.587.578.59.59 0 1 1 .023-1.18.6.6 0 0 1 .564.602z",
    transform: "translate(-3302.636 -1284.7)",
    style: {
      fill: "#030303"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3724",
    d: "m3516.249 1166.4-.149-.084c-.632-.364-1.262-.732-1.9-1.089-.141-.079-.169-.135-.081-.287q2.9-5 5.781-10.01c.074-.128.121-.188.282-.092.633.38 1.275.748 1.92 1.108.156.087.142.153.063.289q-2.888 4.989-5.769 9.983c-.035.063-.052.147-.147.182z",
    transform: "translate(-3494.443 -1143.466)",
    style: {
      fill: "#f84525"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3725",
    d: "M3604.012 1118.017a1.317 1.317 0 0 1 1.365 1.756 12.373 12.373 0 0 1-.592 1.087c-.061.114-.123.092-.212.04q-.995-.579-1.994-1.15c-.1-.055-.113-.105-.054-.2.195-.319.371-.65.574-.963a1.166 1.166 0 0 1 .913-.57z",
    transform: "translate(-3576.291 -1109.428)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3726",
    d: "m3507.431 1312.128-1.983 1.462.194-1.788c0-.02.008-.039.01-.058.086-.6.086-.6.625-.286z",
    transform: "translate(-3486.459 -1288.303)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3727",
    d: "M3362.652 1068.444a4.256 4.256 0 1 1 6.97-.155c-.1.145-.141.147-.241.009a3.71 3.71 0 0 0-1.438-1.2c-.2-.094-.129-.178-.047-.307a2.512 2.512 0 0 0-.693-3.29 2.122 2.122 0 0 0-3.234 1.53 2.492 2.492 0 0 0 .324 1.821c.07.1.076.16-.052.222a4.121 4.121 0 0 0-1.589 1.37z",
    transform: "translate(-3353.499 -1057.268)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3728",
    d: "M3387.451 1147.079a4.323 4.323 0 0 1-2.267-.771c-.126-.086-.115-.141-.048-.254a2.98 2.98 0 0 1 4.969.005c.072.121.061.17-.057.252a4.577 4.577 0 0 1-2.597.768z",
    transform: "translate(-3375.042 -1134.149)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3729",
    d: "M3408.063 1099.051a.969.969 0 0 1-1.255 1.079 1.157 1.157 0 0 1-.634-1.407.955.955 0 0 1 .883-.815.972.972 0 0 1 1.006 1.143z",
    transform: "translate(-3394.539 -1090.811)",
    style: {
      fill: "#fefefe"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCreation);
export default __webpack_public_path__ + "static/media/Profile_Creation.938a0700cf72693d3f50bee32c9dedd1.svg";
export { ForwardRef as ReactComponent };